<article
  class="organizer-activity-planning-date-selection"
  [formGroup]="formGroup"
>
  <!-- delete icon -->
  <header class="organizer-activity-planning-date-selection__header">
    <button
      app-cta
      type="button"
      [iconType]="deleteIconType"
      [variant]="link2Variant"
      ctaClass="organizer-activity-planning-date-selection__header__delete-icon"
      [ariaLabel]="
        'activity_planning.date_selection.header.close-button.label' | translate
      "
      (click)="remove()"
    ></button>
  </header>

  <app-form-datetime
    formControlName="startDateTime"
    [datePlaceholder]="
      'activity_planning.date_selection.input.date.placeholder' | translate
    "
    [isLive]="isLive"
    [timePlaceholder]="
      'activity_planning.date_selection.input.time.placeholder' | translate
    "
    [minDate]="formatDate(startDateMin)"
    [defaultValue]="defaultDateTime"
    errorKey="now"
  >
    <ng-container custom-date-label>
      <vtmn-play-icon
        [name]="iconTypeEnum.CalendarDate"
        [height]="18"
        [width]="18"
        class="self-center text-base mr-1"
      ></vtmn-play-icon>
      {{ dateLabel }}
    </ng-container>

    <ng-container custom-time-label>
      <span class="invisible">
        {{ 'activity_planning.date_selection.start_time' | translate }}
      </span>
    </ng-container>

    <ng-container
      *ngIf="isTimezoneSelectionEnabled || isLive"
      custom-timezone-label
    >
      <vtmn-play-icon
        [name]="iconTypeEnum.Earth"
        [height]="18"
        [width]="18"
        class="self-center text-base mr-1"
      ></vtmn-play-icon>
      {{ 'activity_planning.date_selection.timezone' | translate }}
    </ng-container>
  </app-form-datetime>

  <!-- Recurrence section  -->
  <div
    class="organizer-activity-planning-date-selection__recurrent"
    *ngIf="showRecurrentSection"
  >
    <app-divider></app-divider>

    <!-- Recurrent switch -->
    <app-form-control
      class="organizer-activity-planning-date-selection__recurrent__form"
      [isHorizontal]="true"
    >
      <ng-container custom-label>
        <vtmn-play-icon
          [name]="iconTypeEnum.CalendarCheck"
          [height]="18"
          [width]="18"
          class="self-center text-base mr-1"
        ></vtmn-play-icon>
        {{ 'activity_planning.date_selection.recurrent' | translate }}
      </ng-container>
      <app-form-toggle-switch
        formControlName="recurrentSwitch"
      ></app-form-toggle-switch>
    </app-form-control>

    <div *ngIf="recurrentSwitchValue">
      <!-- Recurrence day selection -->
      <div class="organizer-activity-planning-date-selection__recurrent__days">
        <p
          class="organizer-activity-planning-date-selection__recurrent__days__label"
        >
          {{ 'activity_planning.date_selection.recurrent_week' | translate }}
        </p>
        <app-form-control class="date-selection__recurrent__days__form">
          <app-form-checkbox
            *ngFor="let day of weekControls; index as dayIndex"
            [label]="week[dayIndex].label"
            [formControl]="day"
          ></app-form-checkbox>
        </app-form-control>
      </div>

      <app-divider></app-divider>

      <!-- Recurrence end date -->
      <div class="organizer-activity-planning-date-selection__end-date-form">
        <app-form-control
          class="organizer-activity-planning-date-selection__end-date-form__date"
        >
          <ng-container custom-label>
            <vtmn-play-icon [name]="iconTypeEnum.CalendarDate"></vtmn-play-icon>
            {{ 'activity_planning.date_selection.end_date' | translate }}
          </ng-container>
          <app-form-input
            [type]="inputTypeEnum.Date"
            formControlName="endDate"
            [min]="formatDate(endDateMin)"
            [max]="formatDate(endDateMax)"
          ></app-form-input>
        </app-form-control>
      </div>
    </div>
  </div>
</article>
